// @flow

import * as React from 'react';
import type { VenueResult, HighlightCapacityType } from 'search/types';
import PreviewImages from 'common/components/previewImages/PreviewImages';
import VenuePreviewPrice from 'common/components/venueCard/VenuePreviewPrice';
import VenueLink from 'common/components/venueCard/VenueLink';
import {
  VenueCardContainer,
  VenueCityOverlay,
  VenueImageContainer
} from 'common/components/VenueCard';
import FeaturedVenueIcon from './searchResults/FeaturedVenueIcon';
import VenueInfo from './searchResults/FeaturedVenueInfo';
import SearchActionCreators from 'search/actions/SearchActionCreators';

export type Props = {|
  highlightCapacity: HighlightCapacityType,
  openInNewTab: boolean,
  venue: VenueResult,
  isActive: boolean,
  onClickVenueLink?: () => void
|};

const handleFocus = venueId => {
  SearchActionCreators.focusSearchResult(venueId);
};

export default function FeaturedVenuePreview(props: Props) {
  return (
    <div
      onFocus={() => {
        handleFocus(props.venue.id);
      }}
      onMouseEnter={() => {
        handleFocus(props.venue.id);
      }}
    >
      <VenueCardContainer>
        <VenueImage
          venue={props.venue}
          onClickVenueLink={props.onClickVenueLink}
          openInNewTab={props.openInNewTab}
        />
        <VenueInfo
          venue={props.venue}
          onClickVenueLink={props.onClickVenueLink}
          openInNewTab={props.openInNewTab}
          highlightCapacity={props.highlightCapacity}
          isActive={props.isActive}
        />
      </VenueCardContainer>
    </div>
  );
}

function VenueImage(props: {
  venue: VenueResult,
  openInNewTab: boolean,
  onClickVenueLink?: () => void,
  ...
}) {
  const { venue, onClickVenueLink, openInNewTab } = props;

  return (
    <VenueImageContainer>
      <PreviewImages
        images={venue.preview_images}
        linkWrapper={({ children }) => (
          <VenueLink
            venue={venue}
            openInNewTab={openInNewTab}
            onClickVenueLink={onClickVenueLink}
          >
            {children}
          </VenueLink>
        )}
      />
      <VenuePreviewPrice venue={venue} />
      <VenueCityOverlay city={venue.city} />
      <FeaturedVenueIcon />
    </VenueImageContainer>
  );
}
